import React from 'react'

import {
  AlertTriangle,
  Grid as GridIcon,
  Watch as WatchIcon,
} from 'react-feather'
import { Box, Grid, Tooltip, Typography } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'

import { PeopleCard } from '..'

import {
  EvidenceCard,
  RadialGraphicsCard,
} from 'views/GovernanceProjects/components'

import useStyles from './styles'
import helpers from 'helpers'
import constants from 'constants/index'

const { percentage } = helpers.functions

const OngoingCard = ({
  governanceProject,
  assignments,
  handleOpenModal,
  assignmentRole,
}) => {
  const { ARCHIVED_STATUS_ID } = constants.governanceProject

  const isArchived = governanceProject?.status === ARCHIVED_STATUS_ID

  const overdueActivity = governanceProject?.activities?.overdue > 0

  const classes = useStyles({
    projectStatus: governanceProject?.status,
    overdueActivity,
  })()

  const totalQuestion = governanceProject?.questions?.total ?? 0
  const answeredQuestion = governanceProject?.questions?.answered ?? 0

  const totalEvidences = governanceProject?.evidences?.total ?? 0
  const attachedEvidence = governanceProject?.evidences?.attached ?? 0

  const generalProgress = governanceProject?.generalProgress ?? 0

  const templateLabel = governanceProject?.origin?.name
    ? `Template - ${governanceProject.origin.name}`
    : 'Sem template vinculado'

  return (
    <Box className={classes.cardActionContainer}>
      <Box display="flex" gridGap={8} p={2}>
        <Box>
          <GridIcon />
        </Box>
        <Tooltip title={templateLabel} placement="top">
          <Typography variant="h6" noWrap>
            {templateLabel}
          </Typography>
        </Tooltip>
      </Box>
      <Grid container spacing={2}>
        {isArchived && (
          <Grid item xs={12}>
            <Alert severity="warning">
              <AlertTitle>Projeto arquivado</AlertTitle>
              Este projeto está arquivado e não pode mais ser editado, o que
              ocorre automaticamente quando ele deixa de pertencer ao grupo
              advisor de origem ou quando o template utilizado deixa de existir.
            </Alert>
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <Box className={classes.dateCard}>
            <Box>
              <WatchIcon />
            </Box>
            <Typography variant="h6">
              {helpers.formatters.date(governanceProject?.endDate)}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box className={classes.activityCard}>
            <Box display="flex" gridGap={8} alignItems="center">
              <Box>
                <AlertTriangle />
              </Box>
              <Typography variant="h6">Atividades Atrasadas</Typography>
            </Box>
            <Typography variant="h6">
              {governanceProject?.activities?.overdue}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <RadialGraphicsCard
        title="Progresso Geral"
        subtitle="Pergunta respondida + Evidência anexada"
        percentage={generalProgress}
      />
      <RadialGraphicsCard
        title="Perguntas Respondidas"
        subtitle={`Sua organização respondeu ${answeredQuestion}/${totalQuestion} questões.`}
        value={answeredQuestion}
        percentage={percentage(answeredQuestion, totalQuestion)}
        onlyNumber
      />
      <EvidenceCard
        title="Evidências anexadas"
        value={`${attachedEvidence}/${totalEvidences}`}
        progressValue={percentage(attachedEvidence, totalEvidences)}
      />
      <PeopleCard
        governanceProject={governanceProject}
        handleOpenModal={handleOpenModal}
        assignments={assignments}
        assignmentRole={assignmentRole}
      />
    </Box>
  )
}

export default OngoingCard
